import './style.scss'
import { useState } from "react"
import { AppCenterPopup } from "src/component/CenterPopup"
import { FlexRow, Button, CustomContainer, ScreenTitle, Circle, GridContainer, AppText, AppSpan } from "src/style"
import { IoMdAdd, IoMdRemove } from 'react-icons/io'
import { CenterPopupHeader } from 'src/component'


export const TravelerSelection: React.FC<any> = ({close}) => {

    const [travelers, setTravelers] = useState({adult: 0, children: 0, infant: 0})

    function handleDone () {
        close()
    }

    return (
        <AppCenterPopup height='44.5' zIndex='6' close={close}>
            <CenterPopupHeader close={close} />
            <CustomContainer height="33.5" className='popup-content-container'>
                <CustomContainer topMargin="2">
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Select Travelers</ScreenTitle>
                    <CustomContainer  topMargin='1'>
                        <GridContainer
                            minHeight='7.2'
                            style={{borderBottom: '1px solid #E8E8E8'}}   
                        >
                            <FlexRow justifyContent='space-between' gap='2'>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText textSize='1.8'>Adult</AppText>
                                    <AppSpan textSize='1.2' color='#A0A4A8'>12+ years</AppSpan>
                                </CustomContainer>
                                <FlexRow width='auto' sizeUnit='' gap='1'>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTravelers({...travelers, adult: travelers.adult - 1})}
                                    >
                                        <IoMdRemove style={{color: '#007EFF'}} />
                                    </Circle>
                                    <AppText textSize='1.64' fontWeight='500' fontFamily='Montserrat'>{travelers.adult}</AppText>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTravelers({...travelers, adult: travelers.adult + 1})}
                                    >
                                        <IoMdAdd style={{color: '#007EFF'}} />
                                    </Circle>
                                </FlexRow>
                            </FlexRow>
                        </GridContainer>
                        <GridContainer
                            minHeight='7.2'
                            style={{borderBottom: '1px solid #E8E8E8'}}   
                        >
                            <FlexRow justifyContent='space-between' gap='2'>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText textSize='1.8'>Children</AppText>
                                    <AppSpan textSize='1.2' color='#A0A4A8'>12-12 years</AppSpan>
                                </CustomContainer>
                                <FlexRow width='auto' sizeUnit='' gap='1'>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTravelers({...travelers, children: travelers.children - 1})}
                                    >
                                        <IoMdRemove style={{color: '#007EFF'}} />
                                    </Circle>
                                    <AppText textSize='1.64' fontWeight='500' fontFamily='Montserrat'>{travelers.children}</AppText>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTravelers({...travelers, children: travelers.children + 1})}
                                    >
                                        <IoMdAdd style={{color: '#007EFF'}} />
                                    </Circle>
                                </FlexRow>
                            </FlexRow>
                        </GridContainer>
                        <GridContainer
                            minHeight='7.2'
                            style={{borderBottom: '1px solid #E8E8E8'}}   
                        >
                            <FlexRow justifyContent='space-between' gap='2'>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText textSize='1.8'>Infants</AppText>
                                    <AppSpan textSize='1.2' color='#A0A4A8'>Under 2 years</AppSpan>
                                </CustomContainer>
                                <FlexRow width='auto' sizeUnit='' gap='1'>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTravelers({...travelers, infant: travelers.infant - 1})}
                                    >
                                        <IoMdRemove style={{color: '#007EFF'}} />
                                    </Circle>
                                    <AppText textSize='1.64' fontWeight='500' fontFamily='Montserrat'>{travelers.infant}</AppText>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTravelers({...travelers, infant: travelers.infant + 1})}
                                    >
                                        <IoMdAdd style={{color: '#007EFF'}} />
                                    </Circle>
                                </FlexRow>
                            </FlexRow>
                        </GridContainer>
                        <Button 
                            width='100' sizeUnit='%' topMargin='2' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F'
                            onClick={handleDone}
                        >
                            Done
                        </Button>
                    </CustomContainer>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}
